import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";

export const startRegisterCompareResult = (trackingObject) => {
  
  return async (dispatch, getState) => {
    const state = getState();
    const { compareResultsRegisterEnabled } = state.configuration;
    const { searchInfo } = state.searchInfo;

    trackingObject.searchinfo_id = searchInfo && searchInfo.id;

    if (compareResultsRegisterEnabled === "true") {
      
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_COMPARE_RESULT}`,
        "add",
        trackingObject,
        "POST"
      );

      const body = await resp.json();
      
      if (body.ok) {
        dispatch(registerCompareResult(body.compareResult));
      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } else {

    }
  };
};

const registerCompareResult = (compareResult) => ({
  type: types.COMPARE_RESULT_START_REGISTER,
  payload: compareResult,
});
